module.exports = __webpack_public_path__ + "static/img/bg_2_8.0240d88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_2_8.png
// module id = 9fPZ
// module chunks = 3